import React from 'react'

export default function NoMatch() {
  return (
    <div className='NoMatchArEA'>
      <div className='NotFoundCount'>404</div>
      <div className='NotFoundPageText'>Page Not Found</div>
    </div>
  )
}
